import { Component } from '@angular/core';

import { CategoryNavigationComponent, NavigationNode } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'dp-category-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class DpNavigationComponent extends CategoryNavigationComponent {
  node$: Observable<NavigationNode> = this.service.createNavigation(this.componentData.data$);
}
